(() => {
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const selector = '.sn-heading, .sn-benefit, .sn-demo-media, .sn-steps li, .sn-photo, .sn-richtext, .sn-moment, .sn-offer, .sn-faq-layout';
  let observer;
  const clear = () => {
    observer?.disconnect();
    document.querySelectorAll('[data-sn-reveal]').forEach((el) => {
      el.removeAttribute('data-sn-reveal');
      el.style.removeProperty('--sn-delay');
    });
  };
  const start = () => {
    clear();
    if (preference.matches || window.Shopify?.designMode || !('IntersectionObserver' in window)) return;
    observer = new IntersectionObserver((entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        if (!isIntersecting) return;
        target.setAttribute('data-sn-reveal', 'visible');
        observer.unobserve(target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -24px 0px' });
    document.querySelectorAll(selector).forEach((el) => {
      // Never conceal content already visible, including restored scroll positions.
      if (el.getBoundingClientRect().top < window.innerHeight) return;
      el.setAttribute('data-sn-reveal', 'pending');
      const siblings = Array.from(el.parentElement.children);
      el.style.setProperty('--sn-delay', `${Math.min(siblings.indexOf(el), 2) * 65}ms`);
      observer.observe(el);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  preference.addEventListener('change', start);
  window.addEventListener('pageshow', start);
  document.addEventListener('shopify:section:load', start);
  document.addEventListener('shopify:section:unload', start);
})();
